export const RESTRICTION_ACTIVE_PAID_SUBSCRIPTION = 'ActivePaidSubscription'

export const getDeletionRestrictions = (responseData) => {
  const restrictions = responseData?.restrictions
  if (!Array.isArray(restrictions)) {
    return []
  }
  return restrictions
}

export const getDeletionErrorMessages = (responseData) => {
  const restrictions = getDeletionRestrictions(responseData)
  if (restrictions.length) {
    return restrictions.map((restriction) => restriction.message).filter(Boolean)
  }
  return [responseData?.message || 'Não foi possível concluir a operação.']
}

export const getActivePaidSubscriptionRestrictions = (responseData, accountId = null) => {
  return getDeletionRestrictions(responseData).filter((restriction) => {
    if (restriction.code !== RESTRICTION_ACTIVE_PAID_SUBSCRIPTION) {
      return false
    }
    if (!accountId) {
      return true
    }
    const accountIds = restriction.account_ids || []
    return accountIds.some((id) => String(id) === String(accountId))
  })
}

export const hasForceablePaidSubscriptionRestriction = (responseData, accountId = null) =>
  getActivePaidSubscriptionRestrictions(responseData, accountId).length > 0

export const getRestrictionAccountIds = (restrictions = []) => {
  const ids = new Set()
  restrictions.forEach((restriction) => {
    ;(restriction.account_ids || []).forEach((id) => ids.add(id))
  })
  return Array.from(ids)
}
